import * as React from 'react';
import * as PropTypes from 'prop-types';

const propTypes = {
    iconClass: PropTypes.string.isRequired,
    onMouseEnter: PropTypes.func,
    onClick: PropTypes.func
};

const TooltipIconUI = (props) => {

    const attributes: any = {
        className: `tooltip-container ${props.iconClass}`
    };

    if (typeof props.onClick === 'function') {
        attributes.onClick = props.onClick;
    }

    if (typeof props.onMouseEnter === 'function') {
        attributes.onMouseEnter = props.onMouseEnter;
    }

    return (
        <div {...attributes}>
        </div>
    );
};

(TooltipIconUI as any).propTypes = propTypes;

export default TooltipIconUI;
